// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PosTrxAreaPanel_wrapper__JG_0x"};